import { observer, inject } from 'mobx-react';
import * as React from 'react';
import {Grid, FormControl, Select, MenuItem, FormControlLabel, Checkbox} from '@material-ui/core';
import {action, computed} from 'mobx';
import {CustomersStore} from "../../stores/customers-store";

interface Props {
  customersStore?: CustomersStore;
}

@inject('customersStore')
@observer
class CustomerFuelLevyConfiguration extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
    this.handleIsFuelLevyExemptChange = this.handleIsFuelLevyExemptChange.bind(this);
  }

  public render() {
    return <div className="customer-fuel-levy-configuration">
      <Grid container>
        <Grid item xs={1} />
        <Grid item xs={10}>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.isFuelLevyExempt}
                onChange={this.handleIsFuelLevyExemptChange}
                name="isFuelLevyExempt"
              />
            }
            label="Fuel Levy Exempt"
          />
        </Grid>
        <Grid item xs={1} />
      </Grid>
    </div>
  }

  @computed
  private get isFuelLevyExempt(): boolean {
    return this.props.customersStore!.customer!.isFuelLevyExempt
  }

  @action
  private handleIsFuelLevyExemptChange(_: any, exempt: boolean) {
    this.props.customersStore!.customer.update('isFuelLevyExempt', exempt)
  }
}

export default CustomerFuelLevyConfiguration;
